import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";

const PostDetail = ({ post }) => {
  // let postResponse;
  const [postHtml, setPostHtml] = useState(post || null); // Use initial post HTML from SSR or null
  const { slug } = useParams();
  const location = useLocation();
  const metaTitle = location.state?.title;
  const metaDescription = location.state?.description;
  useEffect(() => {
    if (!post) {
      const fetchResponse = async () => {
        const response = await fetch(`/api/wp/${slug}`);
        const textResponse = await response.text();
        setPostHtml(textResponse);
      };
      fetchResponse();
    }
  }, [post, slug]);
  let canonicalUrl = "";
  if (typeof window !== "undefined") {
    canonicalUrl = `${window.location.origin}${location.pathname}`;
  }
  return (
    <div className="container-md mt-5 surface-card shadow-1 border-round-xl p-3 transition-all hover:shadow-3 blog-detail-card">
      {postHtml || post ? (
        /* <Card> */
        <>
          <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <link rel="canonical" href={canonicalUrl} />
          </Helmet>
          {/* <main className="container">
            <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
            <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
          </main> */}
          <div
            // style={{ fontFamily: "sans-serif" }} // Style your HTML content
            dangerouslySetInnerHTML={{ __html: postHtml }} // Render HTML safely
          ></div>
        </>
      ) : (
        /* </Card> */
        <i className="pi pi-spin pi-spinner fs-1" />
        /* <p>Loading post...</p> */
      )}
    </div>
  );
  // <div dangerouslySetInnerHTML={{ __html: postResponse }}></div>;
  // <div className="container mt-5">
  //   {post ? (
  //     <Card
  //       title={
  //         <div
  //           dangerouslySetInnerHTML={{ __html: post.title.rendered }}
  //         ></div>
  //       }
  //     >
  //       <div
  //         style={{ fontFamily: "sans-serif" }}
  //         className="content"
  //         dangerouslySetInnerHTML={{ __html: post.content.rendered }}
  //       ></div>
  //     </Card>
  //   ) : (
  //     <p>Loading post...</p>
  //   )}
  // </div>
};

export default PostDetail;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom"; // Hook to get URL params
// import { Card } from "primereact/card";

// const PostDetail = () => {
//   const { slug } = useParams();
//   const [post, setPost] = useState(null);

//   useEffect(() => {
//     const fetchPost = async () => {
//       try {
//         const response = await axios.get(`/api/wp/${slug}`);
//         console.log(response);
//         setPost(response.data[0]);
//       } catch (error) {
//         console.error("Error fetching the post:", error);
//       }
//     };
//     fetchPost();
//   }, [slug]);

//   return (
//     <div className="container mt-5">
//       {post ? (
//         <Card
//           title={
//             <div
//               dangerouslySetInnerHTML={{ __html: post.title.rendered }}
//             ></div>
//           }
//         >
//           <div
//             style={{ fontFamily: "sans-serif" }}
//             className="content"
//             dangerouslySetInnerHTML={{ __html: post.content.rendered }}
//           ></div>
//         </Card>
//       ) : (
//         <p>Loading post...</p>
//       )}
//     </div>
//   );
// };

// export default PostDetail;
